import { module } from "modujs";
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                openButton: 'openPhotoSwipe'
            }
        }

        this.isEnabled = true
    }

    init() {
        /////////////////////////
        // Get image node element
        const $images = this.$('image')
        if (!$images.length) {
            this.disableZoom()
            return
        }
        const $image = $images[0]


        /////////////////////////
        // Items
        const zoomSrc = this.getData('src')
        const zoomWidth = this.getData('width')
        const zoomHeight = this.getData('height')

        if (!zoomSrc || !zoomWidth || !zoomHeight) {
            this.disableZoom()
            return
        }

        this.items = [{
            src: zoomSrc,
            w: zoomWidth,
            h: zoomHeight
        }]
        

        /////////////////////////
        // Get photo swipe container
        this.$photoSwipeEl = document.querySelector('.pswp');
        this.$photoSwipeEl.inert = true

        /////////////////////////
        // Options
        this.options = {
            history: false,
            getThumbBoundsFn: function() {
                const pageYScroll = window.pageYOffset || document.documentElement.scrollTop
                const rect = $image.getBoundingClientRect(); 
                return {
                    x:rect.left, 
                    y:rect.top + pageYScroll, 
                    w:rect.width
                };
            }
        } 
    }

    openPhotoSwipe() {
        if (!this.isEnabled) return

        // New instance
        const galleryInstance = new PhotoSwipe( this.$photoSwipeEl, PhotoSwipeUI_Default, this.items, this.options);
        // Bind events
        this.bindEvents(galleryInstance)
        // Launch gallery
        galleryInstance.init();

    }

    bindEvents(galleryInstance) {
        this.onZoomBind = this.onZoom.bind(this)
        this.onDestroyBind = this.onDestroy.bind(this)
        galleryInstance.listen('initialZoomIn', this.onZoomBind);
        galleryInstance.listen('destroy', this.onDestroyBind);
    }

    disableZoom() {
        // Disable zoom trigger
        this.isEnabled = false

        // Hide zoom button
        const $buttons = this.$('openButton')
        if (!$buttons.length) return
        const $button = $buttons[0]

        $button.classList.add('is-hidden')
    }

    onZoom() {
        this.$photoSwipeEl.inert = false
        
        const $main = document.querySelector('main');
        $main.inert = true

        html.classList.add('has-photo-zoom-open');

        const $closeBtn = this.$photoSwipeEl.querySelector('.pswp__button--close');
        setTimeout(() => {
            $closeBtn.focus()
        }, 1000)
    }
    
    onDestroy() {
        this.$photoSwipeEl.inert = true

        const $main = document.querySelector('main');
        $main.inert = false

        html.classList.remove('has-photo-zoom-open');
    }

    destroy() {
        super.destroy()
    }
}